import { render } from "./CoachesList.vue?vue&type=template&id=56f0c105&scoped=true"
import script from "./CoachesList.vue?vue&type=script&lang=js"
export * from "./CoachesList.vue?vue&type=script&lang=js"

import "./CoachesList.vue?vue&type=style&index=0&id=56f0c105&scoped=true&lang=css"

import exportComponent from "D:\\vue\\Vue_Lessons\\coachApps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f0c105"]])

export default __exports__